import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import ControlTitle from "../ControlTitle";
import SignatureCanvas from "react-signature-canvas";

class Signature extends Component {
  constructor(props) {
    super(props);
    var style = getComputedStyle(document.body);

    this.state = {
      base64: "",
      sigColour: "#000000"
    };
  }

  componentDidMount() {
    if (this.props.element_value !== "") {
      this.setState({ base64: this.props.element_value });
    }
  }

  handleChange(e) {
    var x = this.refs.sigCanvas.getCanvas().toDataURL();
    this.props.onChange(this.props.repeatingForm, this.props.element_id, x);
  }

  renderSignature() {
    const { validate, error } = this.props;

    if (this.state.base64 !== "" && this.state.base64 !== null) {
      return (
        <div style={{ marginBottom: "5px" }} className="signatureImage">
          <img style={{ width: 460 }} src={this.state.base64} />
        </div>
      );
    }
    if (validate && error) {
      return (
        <SignatureCanvas
          ref="sigCanvas"
          onEnd={this.handleChange.bind(this)}
          penColor={this.state.sigColour}
          canvasProps={{ width: 500, height: 225, className: "SignatureError" }}
        />
      );
    }

    return (
      <SignatureCanvas
        ref="sigCanvas"
        onEnd={this.handleChange.bind(this)}
        penColor={this.state.sigColour}
        canvasProps={{ width: 500, height: 225, className: "Signature" }}
      />
    );
  }

  resetSign() {
    if (this.state.base64 !== "") {
      this.setState({ base64: "" });
    } else {
      this.refs.sigCanvas.clear();
    }

    this.props.onChange(
      this.props.repeatingForm,
      this.props.element_id,
      ".png",
      ""
    );
  }

  render() {
    const { element_value, element_prompt, ...formControl } = this.props;

    return (
      <Form.Field>
        <ControlTitle
          text={element_prompt}
          optional={formControl.element_optional === "1" ? true : false}
        ></ControlTitle>
        <div style={{ paddingBottom: "10px" }}>
          <div
            onClick={this.resetSign.bind(this)}
            style={{
              maxWidth: "500px",
              textDecoration: "underline",
              cursor: "pointer",
              paddingBottom: "5px",
              textAlign: "right"
            }}
          >
            Reset
          </div>
          {this.renderSignature()}
        </div>
      </Form.Field>
    );
  }
}

Signature.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired,
  element_id: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

export default Signature;



// WEBPACK FOOTER //
// ./src/components/Signature/index.js